import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExperienceService {
  private yearsOfExperienceBeforeJoining = 0;
  private monthsOfExperienceBeforeJoining = 0;
  private yearsOfExperienceAfterJoining = 0;
  private monthsOfExperienceAfterJoining = 0;
  

  setExperienceBeforeJoining(yearBefore:number,monthBefore:number) {
    this.yearsOfExperienceBeforeJoining = yearBefore;
    this.monthsOfExperienceBeforeJoining = monthBefore;
  }

  setExperienceAfterJoining(yearAfter:number,monthAfter:number) {
    this.yearsOfExperienceAfterJoining = yearAfter;
    this.monthsOfExperienceAfterJoining = monthAfter;
  }
  getTotalExperience(): string {
    let totalExperienceYears = 0;
    let totalExperienceMonths = 0;
    totalExperienceYears=this.yearsOfExperienceBeforeJoining+this.yearsOfExperienceAfterJoining;
    totalExperienceMonths=this.monthsOfExperienceBeforeJoining+this.monthsOfExperienceAfterJoining;
    if(totalExperienceMonths>12)
    {
        totalExperienceYears += Math.floor(totalExperienceMonths / 12);
        totalExperienceMonths = totalExperienceMonths % 12;
    }

return ` ${totalExperienceYears} years ${totalExperienceMonths} months`;
  }
}
